import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import pfp from "../../assets/png/pfp.png";
import mail from "../../assets/svg/mail.svg";
import mob from "../../assets/svg/mob.svg";
import copy from "../../assets/svg/copy.svg";
import cross from "../../assets/svg/cross.svg";
import { Toast, ToastContainer } from "react-bootstrap";
import clk from "../../assets/svg/clockred.svg";
import { getCookie } from '../getcookie.js';
import axios from 'axios';

const DiscoverModal = ({ show, bookingData, onHide }) => {
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarStatus, setSnackbarStatus] = useState(false);
    const handleSnackbarShow = () => setShowSnackbar(true);
    const handleSnackbarClose = () => setShowSnackbar(false);

    const apiUrl = process.env.REACT_APP_API_URL;
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);



    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Body className="p-4" style={{ borderRadius: "24px" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex flex-column" style={{ gap: "12px" }}>
                        <h5 className="fw-bold text-dark mb-0">{bookingData ? bookingData.title : "Loading..."}</h5>
                        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                            <img src={clk} style={{ height: "16px", width: "16px" }} alt="Clock" />
                            <div style={{ fontWeight: "500", color: "#842234", fontSize: "14px" }}>
                                {bookingData ? bookingData.time : "Loading..."}
                            </div>
                        </div>
                    </div>
                    <Button variant="link" onClick={onHide} className="p-0">
                        <img src={cross} alt="Close" width="36" height="36" />
                    </Button>
                </div>

                <div className="d-flex align-items-center mb-3 gap-3">
                    <img
                        src={bookingData?.profile_image || pfp}
                        alt="Profile"
                        width="60"
                        height="60"
                        style={{ borderRadius: "50%", objectFit: "cover" }}
                    />
                    <div>
                        <h6 className="mb-1 fw-semibold">{bookingData ? bookingData.user : "Loading..."}</h6>
                        <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                            {bookingData ? `Booked on ${bookingData.booked}` : "Loading..."}
                        </p>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center p-2">
                    <div className="d-flex align-items-center gap-2">
                        <img src={mail} width="16" height="16" alt="Email" />
                        <span className="text-dark">{bookingData ? bookingData.email : "Loading..."}</span>
                    </div>
                    <Button onClick={async () => {
                        await navigator.clipboard.writeText(bookingData.email ?? '');
                        setSnackbarMessage("Copied to clipboard");
                        setSnackbarStatus(true);
                        handleSnackbarShow()
                    }} variant="link" className="p-0">
                        <img src={copy} width="16" height="16" alt="Copy" />
                    </Button>
                </div>

                <div className="d-flex justify-content-between align-items-center p-2">
                    <div className="d-flex align-items-center gap-2">
                        <img src={mob} width="16" height="16" alt="Phone" />
                        <span className="text-dark">{bookingData ? bookingData.contact_number : "Loading..."}</span>
                    </div>
                    <Button onClick={async () => {
                        await navigator.clipboard.writeText(bookingData.contact_number ?? '');
                        setSnackbarMessage("Copied to clipboard");
                        setSnackbarStatus(true);
                        handleSnackbarShow()
                    }} variant="link" className="p-0">
                        <img src={copy} width="16" height="16" alt="Copy" />
                    </Button>
                </div>
            </Modal.Body>
            <ToastContainer position="top-end">
                <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? 'success' : 'danger'} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
                    {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
                    <Toast.Body style={{ color: '#ffffff' }}>{snackbarMessage}</Toast.Body>
                </Toast>
            </ToastContainer>
        </Modal>
    );
};

export default DiscoverModal;

